module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-left-disabled-small.574bd947.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-left-disabled-small.png
// module id = 2636
// module chunks = 11